module.exports = __webpack_public_path__ + "img/japan-liver-cancer-female.2e05539a.png";